import { render, staticRenderFns } from "./CollectingTypeForm.vue?vue&type=template&id=8b2092ea"
import script from "./CollectingTypeForm.vue?vue&type=script&lang=js"
export * from "./CollectingTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports